import type { Event } from 'models';
import { Col, Row } from 'ui';
import { NodeBookmarkButton } from 'features/bookmark';
import { EventRsvpStatus } from '../../event-rsvp-status';

type P = {
  event: Event;
};

const ExtraActions = ({ event }: P) => {
  if (event.type === 'reminder') {
    return null;
  }

  return (
    <Row align="middle" gutter="xs">
      <Col>
        <EventRsvpStatus event={event} />
      </Col>
      {event.type === 'telehealth_visit' ? null : (
        <Col>
          <NodeBookmarkButton event={event} />
        </Col>
      )}
    </Row>
  );
};

export default ExtraActions;
